import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import {
  IImageBreakpoint,
  IMedia,
  MediaObjectFit,
  MediaType,
} from '@epicuro-next/ataraxia/models';

@Component({
  selector: 'atx-media-lightbox',
  templateUrl: './media-lightbox.component.html',
  styleUrls: ['./media-lightbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MediaLightboxComponent {
  public mediaType = MediaType;
  public current360ImageUrl = '';
  public isMobile$ = atxIsMobile$;
  public MediaObjectFit = MediaObjectFit;

  public videoPlayerProps = {
    autoplay: true,
    muted: true,
    controls: true,
  };

  @Input()
  public mediaList: IMedia[];

  @Input()
  public selectedIndex = 0;

  @Input()
  public maxWidth?: number;

  @Input()
  public imageBreakPoints?: IImageBreakpoint[];

  @Input()
  public asideContent?: TemplateRef<HTMLElement>;

  @Output()
  public closeButtonPress = new EventEmitter<void>();

  @HostListener('swipeLeft')
  public next() {
    this.selectedIndex = (this.selectedIndex + 1) % this.mediaList.length;
  }

  @HostListener('swipeRight')
  public previous() {
    if (this.selectedIndex === 0) {
      this.selectedIndex = this.mediaList.length - 1;
    } else {
      this.selectedIndex = this.selectedIndex - 1;
    }
  }

  @HostListener('document:keyup.escape')
  public closeLightBox() {
    this.closeButtonPress.emit();
  }
}
